import React from "react";
import { ITableColumn, DataTableDefaultCellTemplates, DataTableEventArgs, DataTableState } from "../../../../components";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

export default class PolicyTransactionPremiumService {
  getPremiumTableColumns = (onRowClick: any, onRowDeleteClick: any, tabIndex: number): ITableColumn[] => {
    return [
        {
        tabIndex: tabIndex,
        key: "expander",
        title: "",
            width: "40px",
            cellTemplate: DataTableDefaultCellTemplates.RowExpander.CellTemplate,
        cellClickHandler: (dtEventArgs) => {
          const { rowData } = dtEventArgs;
          onRowClick(rowData); // Directly call the parent component's `onRowClick` method
            },
            onKeyDownHandler: (dtEventArgs: DataTableEventArgs) => {
                const { eventData, rowData } = dtEventArgs;
                if (eventData.code === "Enter" || eventData.key === "Enter" || eventData.code === "Space" || eventData.key === " ") {
                    onRowClick(rowData);
                }
            },
        cellTdClassName: "expander-cell-td",
      },
      {
        header: "Premium",
        field: "premium",
        width: "20%",
        cellTemplate: (rowData) => <span>{rowData.premium == null ? "" : Number(rowData.premium).toFixed(2)}</span>,
      },
      {
        header: "Billed Premium",
        field: "billedPremium",
        width: "20%",
        cellTemplate: (rowData) => <span>{rowData.billedPremium}</span>,
      },
      {
        header: "Written Premium",
        field: "writtenPremium",
        width: "20%",
        cellTemplate: (rowData) => <span>{rowData.writtenPremium}</span>,
      },
      {
        header: "Full Term Premium",
        field: "fullTermPremium",
        width: "20%",
        cellTemplate: (rowData) => <span>{rowData.fullTermPremium}</span>,
      },
      // {
      //   header: "How Billed",
      //   field: "howBilled",
      //   width: "20%",
      //   cellTemplate: (rowData) => <span>{rowData.howBilled}</span>,
      // },
      // {
      //   width: "5%",
      //   cellTemplate: DataTableDefaultCellTemplates.DeleteCellTemplate.CellTemplate,
      //   cellClickHandler: (dtEventArgs) => onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column),
      // },
    ];
  };
}